import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Button, Upload, Icon, Modal, Input, Popconfirm, message, Divider} from "antd";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import FormModal from "../../components/FormModal";
import * as api from "../../api/product_price";
import ProductPriceLogDrawer from "./log";


const AddButton = authWrapper('add')(Button);
const EditFragment = authWrapper('edit')(Fragment);
const ImportButton = authWrapper('import')(Button);
const DeletePopconfirm = authWrapper('delete')(Popconfirm);

class ProductPrice extends Component {
    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '物料ID',
            dataIndex: 'product_id',
            sorter: true
        },
        {
            title: '单位',
            dataIndex: 'unit',
        },
        {
            title: '价格',
            dataIndex: 'price',
            sorter: true
        },
        {
            title: '创建人',
            dataIndex: 'create_by',
        },
        {
            title: '创建日期',
            dataIndex: 'create_time',
            sorter: true
        },
        {
            title: '操作',
            render: (record) => {
                return (
                    <span>
                        <EditFragment>
                            <a onClick={() => this.handleModalShow(record)}>编辑</a>
                            <Divider type={'vertical'}/>
                            <Popconfirm title={'是否确认更新订单价格状态'}
                                        onConfirm={() => this.handleUpdateOrderPriceStatus(record.id)}>
                                <a>更新订单</a>
                            </Popconfirm>
                            <Divider type={'vertical'}/>
                        </EditFragment>
                        <DeletePopconfirm title={'是否确认删除'} onConfirm={() => this.handleDelete(record.id)}>
                            <a>删除</a>
                        </DeletePopconfirm>
                    </span>
                )
            }
        }
    ];

    modifyFields = [
        {
            dataIndex: 'id',
            visible: false
        },
        {
            title: '物料ID',
            dataIndex: 'product_id',
            rules: [{
                required: true, message: '请输入物料ID',
            }],
        },
        {
            title: '单位',
            dataIndex: 'unit',
        },
        {
            title: '价格',
            dataIndex: 'price',
            rules: [{
                required: true, message: '请输入价格',
            }],
        },
    ];

    dataTable = undefined

    state = {
        modalVisible: false,
        modalRecord: {},
        modalSaving: false,
        logDrawerVisible: false,

        uploadModalVisible: false,
        uploading: false,
        files: [],

        searchKeyword: null
    };

    handleModalShow = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    };

    handleModalOk = (fieldsValue) => {
        this.setState({
            modalSaving: true,
        });
        api.modifyProductPrice({...fieldsValue}).then(() => {
            this.setState({
                modalSaving: false,
                modalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                modalSaving: false,
            });
        })
    };


    handleImportOk = () => {
        this.setState({
            uploading: true,
        });
        api.importProductPrices(this.state.files[0]).then(() => {
            this.setState({
                uploading: false,
                uploadModalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                uploading: false,
            });
        })
    };

    handleDelete = (priceId) => {
        api.deleteProductPrice(priceId).then(() => {
            this.dataTable.fetch();
            message.success('删除成功')
        })
    };

    handleUpdateOrderPriceStatus = (id) => {
        api.updateOrderPriceStatus(id).then(() => {
            message.success("更新成功")
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'产品价格'} content={
                <div style={{textAlign: 'center'}}>
                    <Input.Search style={{width: 500}}
                                  enterButton="搜索"
                                  onSearch={(value) => this.setState({searchKeyword: value})}
                    />
                </div>
            }>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <AddButton type={"primary"} onClick={() => this.handleModalShow()}>新增</AddButton>
                        <Button style={{marginLeft: 10}} type={"primary"}
                                onClick={() => this.setState({logDrawerVisible: true})}>日志</Button>
                        <ImportButton style={{marginLeft: 10}} type={"primary"}
                                      onClick={() => this.setState({uploadModalVisible: true})}>导入</ImportButton>
                    </div>
                    <StandardTable columns={this.columns}
                                   rowKey={'id'}
                                   url={'/api/product/price/'}
                                   ref={(table) => this.dataTable = table}
                                   keyword={this.state.searchKeyword}
                    />
                </Card>
                <FormModal visible={this.state.modalVisible}
                           confirmLoading={this.state.modalSaving}
                           record={this.state.modalRecord}
                           fields={this.modifyFields}
                           onOk={this.handleModalOk}
                           onCancel={() => this.setState({modalVisible: false})}
                />
                <ProductPriceLogDrawer visible={this.state.logDrawerVisible}
                                       onClose={() => this.setState({logDrawerVisible: false})}/>
                <Modal visible={this.state.uploadModalVisible}
                       onOk={this.handleImportOk}
                       onCancel={() => this.setState({uploadModalVisible: false})}
                       afterClose={() => this.setState({files: []})}
                       confirmLoading={this.state.uploading}
                       destroyOnClose
                >
                    <Upload beforeUpload={(file) => {
                        this.setState((state) => ({files: [...state.files, file]}))
                        return false
                    }}
                            onRemove={(file) => {
                                const files = this.state.files
                                files.splice(files.indexOf(file), 1)
                                this.setState({
                                    files: files
                                })
                            }}
                    >
                        <Button>
                            <Icon type="upload"/>选择Excel
                        </Button>
                    </Upload>
                </Modal>
            </PageHeaderLayout>
        )
    }
}

export default ProductPrice;